module.exports = "/images/pillWhiteBlurb.png?814f664850f6fb4c3f0067251112bfd7";